// @ts-nocheck
import { PageHeader } from 'components'
import React, { useEffect, useRef, useState } from 'react'
import { EmailEditor } from 'react-email-editor'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import CreateEmailCampaign from './CreateEmailCampaign'
import { createOrUpdateEmailTemplates, getEmailTemplates } from 'store/actions/emailTemplateActions'

const EditEmailTemplate = () => {
  const history = useHistory()
  const emailEditorRef = useRef(null)
  const { templateId } = useParams()
  const [template, setTemplate] = useState()
  const [isSliderOpen, setIsSliderOpen] = useState(false)

  useEffect(() => {
    getEmailTemplates(templateId)
      .then((response) => setTemplate(response.data))
      .catch((error) => console.log(error))
  }, [])

  const editTemplate = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      createOrUpdateEmailTemplates({
        ...template,
        unlayerConfig: data
      })
        .catch((error) => console.log(error))
    })
  }

  const onLoad = () => {
    emailEditorRef.current.editor.loadDesign(template.unlayerConfig.design)
  }

  const RightContent = () => (
    <>
      <button
        className='text-softBlack text-center text-base font-medium py-2 px-6 rounded flex items-center focus:ring-0 hover:bg-softBlack30 transition-all'
        onClick={() => history.goBack()}
      >
        Go back
      </button>
      <button
        className='text-softBlack text-center text-base font-medium py-2 px-6 rounded flex items-center border border-black'
        onClick={() => setIsSliderOpen(true)}
      >
        Create Campaign
      </button>
      <button
        className='flex justify-center items-center font-bold p-3 px-6 bg-volt rounded cursor-pointer'
        onClick={editTemplate}
      >
        Save
      </button>
    </>
  )

  return (
    <>
      <div className='flex flex-col relative h-full'>
        <PageHeader
          title={template?.name ? `Edit Email Template: ${template?.name}` : 'Edit Email Template'}
          rightContent={<RightContent />}
        />
        <EmailEditor
          ref={emailEditorRef}
          onLoad={template?.unlayerConfig?.html ? onLoad : null}
        />
      </div>
      <CreateEmailCampaign onClose={() => setIsSliderOpen(false)} open={isSliderOpen} />
    </>
  )
}

export default EditEmailTemplate
